import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/store/reducers';
import { Request } from 'src/store/actions/offerActions';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable({
  providedIn: 'root'
})
export class ViewrequestsService {
  links : any ;
  constructor(private http: HttpService, private store: Store<AppState>) { }

  static formFields() {
    return {
      'email': [null],
      'link_use_limit': [null],
      'number_of_links': [null, Validators.required],
      'start_date_time': [null, Validators.required],
      'end_date_time': [null, Validators.required],
      'tupas_required': [null],
      'login_required': [null],
      'door_lock': [null],
      'locker_id': [null],
      'sublocker': [null],
      'store_id': [null, Validators.required],
    }
  }

  private subject = new Subject<any>();

 setLink(val){
    this.links = val;
 }

 getLink(){
  return this.links
 }
  
  sendMessage(link: any) {
    this.subject.next(link);
  }

  clearMessage() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  viewAllRequests(range) {
    return this.http.query('get', 'my-requests?' + range, {});
  }
  dispatchRequestAction(payload) {
    this.store.dispatch(new Request(payload));
  }

  addLinkGenerate(linkPayload) {
    return this.http.query('post', 'generate-links', {}, '', linkPayload);
  }

  getLocker() {
    return this.http.query('get', 'store', {});
  }

  getLockerById(id) {
    return this.http.query('get', 'store/' + id, {});
  }

  getSubLockerById(id) {
    return this.http.query('get', 'locker/' + id, {});
  }
 
  getAllEntity() {
    return this.http.query('get', 'entity' , {});
  }


  getAllLockerUser() {
    return this.http.query('get', 'locker-user' , {});
  }

  openLock(url) {
    return this.http.query('get', url, {});
  }
}
